<template>
  <div class="jgsd-upload-container">
    <div :class="['list-container', { 'list-container-expand': expandFlag }]">
      <el-tabs
        v-model="currentList"
        @tab-click="handleChangeTab"
      >
        <el-tab-pane
          v-for="item in contentList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        >
          <keep-alive>
            <component
              v-if="item.name === currentList"
              :is="item.name"
              :ref="item.name"
              :is-un-limit-department="false"
              :is-show-status="isNoPassList"
              :btn-arr="btnArr"
              :is-record-condition="isNoPassList"
              :ajax-params="ajaxParams"
              inter-face="postSpcialQuery"
              @changeSelected="changeSelected"
              @updateExpand="updateExpand"
            >
              <el-button
                v-for="(item, index) in btnArr"
                :key="index"
                v-show="handleShow(item)"
                @click="handleCommandList(item.id)"
              >
                {{ item.label }}
              </el-button>
            </component>
          </keep-alive>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-tabs
      v-model="currentTab"
      :class="[
        'tag-tab-conditon',
        { 'tag-no-operate-conditon': !isNoPassList }
      ]"
    >
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <keep-alive>
          <components
            v-if="currentTab === item.name"
            :is="item.name"
            :ref="item.name"
            :is-show-operate="isNoPassList"
            :btn-arr="detailArr"
            :current-item="currentItem"
            :is-can-add="isNoPassList"
            :is-show-review-oper="false"
            @handleCommand="handleCommand"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <sureDialog
      ref="sureDialog"
      class="sureDialog"
      :is-show-footer="true"
      width="450px"
      :is-tran-cancel="true"
      @dialogSure="getSpcialDelete"
    >
      <div class="delete-icon-box">
        <i class="icon icon-warning" />
      </div>
      <div class="delete-text">
        {{ tips }}
      </div>
    </sureDialog>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import notPass from '@components/jgsd/commonList'
// eslint-disable-next-line import/no-duplicates
import passed from '@components/jgsd/commonList'
import detail from '@components/jgsd/detail'
import tag from '@views/jgsd/dataView/components/tag'
import reviewManage from '@views/jgsd/review/components/reviewManage'
import jlxkAPIS from '@apis/jlxk'
import sureDialog from '@components/dialog/cyDialogCommon'
export default {
  name: 'Editor',
  components: {
    detail,
    tag,
    notPass,
    passed,
    reviewManage,
    sureDialog
  },
  props: {},
  data() {
    return {
      currentList: 'notPass',
      contentList: [
        {
          name: 'notPass',
          label: '未通过列表'
        },
        {
          name: 'passed',
          label: '已通过列表'
        }
      ],
      currentTab: 'detail',
      tabList: [
        {
          name: 'detail',
          label: '详情'
        },
        {
          name: 'tag',
          label: '标签'
        },
        {
          name: 'reviewManage',
          label: '审读管理'
        }
      ],
      active: 0,
      expandFlag: true,
      btnArr: [
        {
          id: 'upload',
          label: '上传'
        },
        {
          id: 'delete',
          label: '批量删除'
        },
        {
          id: 'backout',
          label: '批量撤稿'
        }
      ],
      detailArr: [
        {
          id: 'alter',
          label: '修改',
          icon: 'jlxk-data-view-alter'
        },
        {
          id: 'delete',
          label: '删除',
          icon: 'jlxk-review-delete'
        },
        {
          id: 'backout',
          label: '撤稿',
          icon: 'jlxk-review-backout'
        }
      ],
      handleFlag: '',
      isDetail: false,
      currentItem: {}
    }
  },
  computed: {
    ajaxParams() {
      let params = {
        isMy: 1,
        showContent: 0,
        system: 0,
        timeFlag: undefined
      }
      return Object.assign(
        {},
        params,
        this.isNoPassList ? {} : { status: '5' }
      )
    },
    isNoPassList() {
      return this.currentList === 'notPass'
    },
    tips() {
      return this.isDeleteOper ? '您确定要删除吗？' : '您确定要撤稿吗？'
    },
    isDeleteOper() {
      return this.handleFlag === 'delete'
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
  },
  methods: {
    handleChangeTab() {
      this.$nextTick(() => {
        this.changeSelected(this.$refs[this.currentList][0].currentItem)
      })
    },
    // 删除、撤稿
    async getSpcialDelete() {
      let ids = this.$refs[this.currentList][0].checkedLists.join(',')
      let params = {
        ids: this.isDetail ? this.currentItem.id : ids
      }
      if (!this.isDeleteOper) {
        params = Object.assign({}, params, {
          toStatus: 2,
          operate: '撤稿'
        })
      }
      let _apis = this.isDeleteOper
        ? jlxkAPIS.postSpcialDelete
        : jlxkAPIS.postSpcialCheck
      let { status, message } = await _apis({
        data: params
      })
      if (status === 0) {
        this.$refs.sureDialog.cyDialogCommon = false
        this.$refs[this.currentList][0].resetCheck()
        this.$refs[this.currentList][0].totalData = []
        this.$refs[this.currentList][0].getList()
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    handleCommandList(value) {
      if (value === 'upload') {
        this.$router.push({
          path: '/jgsd/editor',
          query: {
            modelId: this.$refs[this.currentList][0].currentIndex,
            categoryId: this.$refs[this.currentList][0].categoryId
          }
        })
        return false
      }
      this.handleCommand({ flag: value, isDetail: false })
    },
    // 操作：删除、撤稿
    handleCommand(value) {
      this.isDetail = value.isDetail
      this.handleFlag = value.flag
      this.$refs.sureDialog.cyDialogCommon = true
    },
    changeSelected(val) {
      this.currentItem = val
    },
    updateExpand(val) {
      this.expandFlag = val
    },
    // 操作行展示条件
    handleShow(value) {
      if (value.id === 'upload') return true
      if (
        !this.$refs[this.currentList] ||
        !this.$refs[this.currentList][0] ||
        !this.$refs[this.currentList][0].isCanOperate
      ) { return false }
      if (value.id === 'delete') return true
      let flag = true
      this.$refs[this.currentList][0].selectedData.forEach(item => {
        if (item.status !== 4) {
          flag = false
          return false
        }
      })
      return flag
    }
  }
}
</script>

<style lang="scss" scoped>
.jgsd-upload-container {
  display: flex;
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      border-radius: 5px 5px 0 0;
      .el-tabs__nav-wrap {
        overflow: auto;
        .el-tabs__nav-scroll {
          height: 49px;
        }
        &::after {
          height: 1px;
        }
      }
      .el-tabs__active-bar {
        bottom: -4px;
      }
      .el-tabs__item {
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #454647;
        padding: 0 30px;
        box-shadow: none;
        &.is-active {
          color: #4497ec;
        }
      }
    }
  }
  /deep/ .el-tabs.tag-tab-conditon {
    width: 440px;
    @extend .comBackground;
    .el-tabs__header {
      width: 100%;
      background: #ffffff;
    }
    .el-tabs__content {
      overflow: initial;
      background-color: #fff;
      min-height: calc(100vh - 150px);
      .data-view-detail-container {
        .detail-container {
          padding: 15px 20px;
          height: calc(100vh - 195px);
          overflow-y: auto;
        }
      }
    }
    &.tag-no-operate-conditon {
      .el-tabs__content {
        .data-view-detail-container {
          .detail-container {
            height: calc(100vh - 147px);
          }
        }
      }
    }
  }
  .list-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 12px 0 0;
    @extend .comBackground;
    /deep/ .el-tabs {
      &__header {
        display: none;
        margin: 0 15px 0 25px;
        .el-tabs__item {
          line-height: 48px;
          padding: 0 60px 0 0;
        }
      }
      &__content {
        overflow: inherit;
      }
    }
    /deep/ .jlxk-data-content {
      position: relative;
      width: 100%;
      margin: 0;
      box-shadow: none;
    }
    &-expand {
      /deep/ .el-tabs {
        &__header {
          display: block;
        }
      }
      /deep/ .jlxk-data-content {
        height: calc(100vh - 145px);
      }
    }
  }
  /deep/ .sureDialog {
    .delete-icon-box {
      width: 60px;
      height: 60px;
      background-color: #f3c245;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
    }
    .delete-text {
      text-align: center;
    }
    .el-dialog__footer {
      margin: 0;
    }
  }
}
</style>
